/* eslint-disable react/jsx-pascal-case */
import { createPath } from 'history';
import React from 'react';
import { __RouterContext as RouterContext } from 'react-router'; // eslint-disable-next-line udemy/import-disallow

import { Link as ReactRouterLink } from 'react-router-dom';
/** Interface for UdemyLink within the Monolith. Extends `LinkProps` from `react-router-dom` */

/** Component for rendering a link that utilizes `react-router-dom` */
export const RouterLink = _ref => {
  let {
    disableRouter = false,
    ...linkProps
  } = _ref;
  return /*#__PURE__*/React.createElement(RouterContext.Consumer, null, context => {
    if (context && !disableRouter) {
      return /*#__PURE__*/React.createElement(ReactRouterLink, linkProps);
    }

    const {
      component,
      innerRef,
      replace,
      to,
      ...anchorProps
    } = linkProps;
    const href = typeof to === 'string' ? to : createPath(to);
    return /*#__PURE__*/React.createElement("a", Object.assign({}, anchorProps, {
      href: href,
      ref: innerRef
    }));
  });
};
//# sourceMappingURL=router-link.react-component.js.map